import React, {Component} from "react";

class WhyChooseUs extends Component {
    render() {
        return (
            <section className="section why-choose-us">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="pr-0 pr-lg-2">
                                <h2 className="section-heading h1 text-dark">Why Choose Us</h2>
                                <p className="mt-30">
                                At iScreenFix, we pride ourselves on our precision and attention to detail when it comes to repairing your electronic devices.
                                </p>
                                <p className="mt-20">
                                As a family-owned and operated business, we understand the importance of reliability and trustworthiness, and we strive to deliver the highest quality service to all of our clients. 
                                Whether its a crecked screen or a malfunctioning component, you can trust iScreenFix to get your devices back up and running in no time.
                                </p>
                                <div className="row text-center">
                                    <div className="col-md-5 col-sm-6 mt-30">
                                        <img src={process.env.PUBLIC_URL + '/assets/images/why-choose-us/01.png'} alt="" />
                                        <h4 className="text-dark mt-15">After Sales Support</h4>
                                    </div>
                                    <div className="col-md-5 col-sm-6 mt-30">
                                        <img src={process.env.PUBLIC_URL + '/assets/images/why-choose-us/02.png'} alt="" />
                                        <h4 className="text-dark mt-15">Client Satisfaction</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 mt-4 mt-lg-0">
                            <div className="row masonry">
                                <div className="col-sm-6">
                                    <div className="block text-center">
                                        <div className="icon">
                                            <img src={process.env.PUBLIC_URL + '/assets/images/why-choose-us/03.png'} alt="" />
                                        </div>
                                        <h4 className="mt-25 text-dark">Skill</h4>
                                        <p className="mt-20">Our team memebers bring unmatched skills to the table in every field.</p>
                                    </div>
                                    {/* why choose us item */}
                                </div>
                                <div className="col-sm-6">
                                    <div className="block text-center mt-30">
                                        <div className="icon">
                                            <img src={process.env.PUBLIC_URL + '/assets/images/why-choose-us/04.png'} alt="" />
                                        </div>
                                        <h4 className="mt-25 text-dark">Experience</h4>
                                        <p className="mt-20">With each technician backed by years of experience, there's no questioning if we are the right ones for the job.</p>
                                    </div>
                                    {/* why choose us item */}
                                </div>
                                <div className="col-sm-6">
                                    <div className="block text-center mt-30">
                                        <div className="icon">
                                            <img src={process.env.PUBLIC_URL + '/assets/images/why-choose-us/05.png'} alt="" />
                                        </div>
                                        <h4 className="mt-25 text-dark">Quality</h4>
                                        <p className="mt-20">With every repair getting inspected before leaving the door and our 1 year parts defect warranty you can guarantee good quality.</p>
                                    </div>
                                    {/* why choose us item */}
                                </div>
                                <div className="col-sm-6">
                                    <div className="block text-center mt-30">
                                        <div className="icon">
                                            <img src={process.env.PUBLIC_URL + '/assets/images/why-choose-us/06.png'} alt="" />
                                        </div>
                                        <h4 className="mt-25 text-dark">Guarantees</h4>
                                        <p className="mt-20">Most repairs are backed by our 1 year warranty to guarantee a working device.</p>
                                    </div>
                                    {/* why choose us item */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default WhyChooseUs;